import React, { createContext, useState, useContext, useEffect } from 'react'
import { useSnackbar } from 'notistack'


const AuthContext = createContext({})

export const useAuth = () => useContext(AuthContext)

export const MrdAuthProvider = ({ children }) => {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)
  const { enqueueSnackbar } = useSnackbar();


  // 🔹 Load user from localStorage
  useEffect(() => {
    try {
      const storedUser = localStorage.getItem("user");
      if (storedUser) {
        setUser(JSON.parse(storedUser));
      }
    } catch (err) {
      console.error("Error loading user:", err);
      enqueueSnackbar("Failed to load user session", { variant: "error" });
    } finally {
      setLoading(false);
    }
  }, [enqueueSnackbar]);

  // ✅ hasRole: true if user’s role or permission matches, or if Admin/SuperAdmin
  const hasRole = (role) => {
    if (!user) return false;
    if (user.superadmin) return true;
    return user.role === role || user.permissions?.includes(role);
  };

  // ✅ hasAnyRole: true if any of roles/permissions match, or if Admin/SuperAdmin
  const hasPermission = (roles = []) => {
    if (!user) return false;
    if (user.superadmin) return true;

    const roleMatch = roles.includes(user.role);
    const permissionMatch = user.permissions?.some((perm) =>
      roles.includes(perm)
    );

    return roleMatch || permissionMatch;
  };



  // const hasPermission = (requiredRole) => {
  //   if (!user) return false
  //   if (user.role === 'ADMIN') return true

  //   const roleHierarchy = {
  //     'ADMIN': 7,
  //     'MRD_INCHARGE': 6,
  //     'HOD': 5,
  //     'DOCTOR': 4,
  //     'CODING_STAFF': 3,
  //     'MRD_STAFF': 2,
  //     'NURSE': 1
  //   }

  //   return roleHierarchy[user.role] >= roleHierarchy[requiredRole]
  // }

  const value = {
    user,
    loading,
    hasPermission,
  }

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  )
}